<template>
  <span class="hoverlist">
    <span class="linecolor">{{ displayText }}</span>
    <div class="hidetext">
      <p class="description">{{ description }}</p>
      <p class="title line1" @click="tourl(url)">{{ title }}</p>
      <p class="detail">
        <span>{{ author }}</span>
        <span>{{ language }}</span>
        <span>{{ publish_date }}</span>
      </p>
    </div>
  </span>
</template>

<script>
export default {
  props: {
    displayText: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    url: {
      type: String,
      required: true,
    },
    author: {
      type: String,
      required: true,
    },
    language: {
      type: String,
      required: true,
    },
    publish_date: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
  },
  methods: {
    tourl(url) {
      window.open(url, "_blank");
    },
  },
};
</script>

<style scoped>
.linecolor {
  color: #2d8cf0;
  text-decoration: underline;
  cursor: pointer;
}

.hidetext {
  width: 460px;
  max-height: 460px;
  padding: 15px;
  display: none;
  background-color: #fff;
  box-shadow: 0px 0px 12px 0px rgba(169, 167, 164, 0.8);
  position: absolute;
  position: absolute;
  bottom: 100%; /* 调整到底部边缘 */
  left: 0; /* 调整到左侧边缘 */
  z-index: 1; /* 确保子元素显示在父元素之上 */
}
.description {
  max-height: 150px;
  overflow: hidden;
  overflow-y: auto;
}
.title {
  font-size: 18px;
  font-weight: bold;
  margin-top: 5px;
  cursor: pointer;
}
.title:hover {
  color: #2d8cf0;
}
/* 修改选择器，让悬浮在.linecolor 或.hidetext 上时都显示.hidetext */
.linecolor:hover + .hidetext,
.hidetext:hover {
  display: inline;
}
.hoverlist {
  position: relative;
}
</style>
